export enum FooterType {
    ALL_PAGES,
    FIRST_PAGE,
    LAST_PAGE,
    PAGE_NUMBER
}